// extracted by mini-css-extract-plugin
export default {"titleContainer":"SettingsForms_titleContainer__H1nZB","itemContainer":"SettingsForms_itemContainer__aK3wc","btnContainer":"SettingsForms_btnContainer__HffH+"};